import { render, staticRenderFns } from "./page-verify.vue?vue&type=template&id=6f88a506&scoped=true"
import script from "./page-verify.vue?vue&type=script&lang=js"
export * from "./page-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88a506",
  null
  
)

export default component.exports